import { Component, OnInit,AfterViewInit, Inject,OnDestroy   } from '@angular/core'; 
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { PeticionesService } from '../servicios/httpservice';
import { trigger, state, style, animate, transition } from '@angular/animations'; 
import { EcommerceCarrService } from '../servicios/ecommerce-carr.service';
 import { Subject } from 'rxjs';
 import { takeUntil } from 'rxjs/operators';

declare const bootstrap: any;
declare var $: any;

@Component({
  selector: 'app-ecommerce',
   //changeDetection: ChangeDetectionStrategy.OnPush, // 👈 ¡CRUCIAL!
  templateUrl: './ecommerce.component.html',
  styleUrls: ['./ecommerce.component.css'],
  animations: [
    trigger('menuAnimation', [
      state('hidden', style({
        transform: 'perspective(600px) rotateY(90deg)', // Empieza doblada
        opacity: 0,
        display: 'none'
      })),
      state('visible', style({
        transform: 'perspective(600px) rotateY(0)', // Plana cuando es visible
        opacity: 1,
        display: 'block'
      })),
      transition('hidden => visible', [
        animate('0.5s ease-out')
      ]),
      transition('visible => hidden', [
        animate('0.5s ease-in') 
      ]),
    ]
   )
  ]
})
export class EcommerceComponent implements  OnInit, AfterViewInit , OnDestroy { 
  private destroy$ = new Subject<void>(); // 👈 Creamos un emisor

  // Inicializamos la cuenta regresiva en 10 segundos
  public timeLeft: number = 10;

  // Define tu fecha objetivo: 11 de Diciembre de 2025 (¡Ojo! El mes es 0-indexado, Diciembre es 11)
  private readonly targetDate: Date = new Date(2025, 11, 11, 0, 0, 0); 
  
  // Variables para mostrar en la plantilla
  public days: number = 0;
  public hours: number = 0;
  public minutes: number = 0;
  public seconds: number = 0;
  public isFinished: boolean = false;

  // Variable para almacenar la referencia del temporizador
  private countdownInterval: any;

  arrayProductosDestacados:any = [];
  arrayCategorias:any = [];
  arrayNovedades:any = [];
  public piePagina:string="info@tu-tienda.com"
  public strConexion:string = "COMERCIAL"
  public hovered:boolean=false;
  public arrayAccesos: any=[]; 
  mostrarElementos = true;
  public arrayLiquidacion:any =[];
  public cartItems:any =[]; 
  public subTotalCar:number = 0;
 private heroStarted = false;
   private lcpObserver?: PerformanceObserver;
private autoplayT?: number;
private heroMO?: MutationObserver;
  public arrayBannerEcommerce:Array<{ strUrl: string; strCorreo?: string; srcset?: string,strMoneda?:number }> = []; 
  public arrayBannerPartner:any =[]; 
constructor(@Inject(DOCUMENT) private document: Document,
private cartService: EcommerceCarrService, 
//private newMenu:NewmenuComponent,
public router: Router,
  public route: ActivatedRoute, public _serviciosService: PeticionesService, public localSt: LocalStorageService){}

  ngOnInit(): void {
    // Iniciamos la cuenta regresiva cuando el componente se inicializa
    this.startCountdown();
    this.fnGetBannersEcommerce();
    this.fnExtaerNuevos();
    this.fnExtaerDestacados();
    this.fnExtaerCategorias();
    this.fnGetBannersPartner()
    
   /* this.arrayAccesos = this.localSt.retrieve('arrayAccesos')?this.localSt.retrieve('arrayAccesos'):[{strOrigen:'TIENDA'  }]; 
  this.user =this.localSt.retrieve('strusuario');
  if(this.user != "" && this.user != null && this.user != undefined ){
    this.router.navigate(['/strUrlHome']);
  }*/
    this.cartService.getCartItems()
    .pipe(  takeUntil(this.destroy$) ) // 👈 Usamos takeUntil
    .subscribe((items) => {
      this.cartItems = items;
      if(this.cartItems.length > 0){
        this.subTotalCar = 0
        this.cartItems.forEach(item => {
         this.subTotalCar =  this.subTotalCar + item.intPrecio 
        });
      }
    })
  }
  ngAfterViewInit(){
     this.deferAutoplayUntilLCP();
   /*  $('#carouselExample').carousel({
      interval: 5000
    }); */
   /* if (this.arrayAccesos && this.arrayAccesos.length > 0) {
        this.newMenu.fnCerrarSesion(); 
        this.newMenu.fnquitarFamilia();
        this.router.navigate(['/tienda']);
      } */
  }

startCountdown(): void {
    // Ejecutamos el cálculo cada segundo
    this.countdownInterval = setInterval(() => {
      this.calculateTimeRemaining();
    }, 1000);
  }

  calculateTimeRemaining(): void {
    const now = new Date().getTime();
    // La diferencia se calcula en milisegundos
    const difference = this.targetDate.getTime() - now;

    // Si la diferencia es positiva (aún no llega la fecha)
    if (difference > 0) {
      // Cálculo de las unidades de tiempo a partir de los milisegundos restantes
      // Constantes de tiempo
      const MS_IN_SECOND = 1000;
      const MS_IN_MINUTE = MS_IN_SECOND * 60;
      const MS_IN_HOUR = MS_IN_MINUTE * 60;
      const MS_IN_DAY = MS_IN_HOUR * 24;

      this.days = Math.floor(difference / MS_IN_DAY);
      
      // Restamos los milisegundos de días para calcular las horas restantes
      const hoursMs = difference % MS_IN_DAY;
      this.hours = Math.floor(hoursMs / MS_IN_HOUR);

      // Restamos los milisegundos de horas para calcular los minutos restantes
      const minutesMs = hoursMs % MS_IN_HOUR;
      this.minutes = Math.floor(minutesMs / MS_IN_MINUTE);
      
      // Restamos los milisegundos de minutos para calcular los segundos restantes
      const secondsMs = minutesMs % MS_IN_MINUTE;
      this.seconds = Math.floor(secondsMs / MS_IN_SECOND);

      this.isFinished = false;

    } else {
      // Si la diferencia es cero o negativa, la cuenta terminó
      this.isFinished = true;
      clearInterval(this.countdownInterval);
      // Opcional: Establecer todos los contadores a 0 al finalizar
      this.days = this.hours = this.minutes = this.seconds = 0;
    }
  }
  
  // Llama esto cuando recibas los banners del API:
  onBannersLoaded(banners: Array<{ strUrl: string; strCorreo?: string; srcset?: string }>) {
    this.arrayBannerEcommerce = banners || [];
    if (!this.arrayBannerEcommerce.length) return;

    const firstUrl = this.arrayBannerEcommerce[0]?.strUrl;
    if (!firstUrl) return;

    const origin = this.getOrigin(firstUrl);
    if (origin) {
      this.safeAddLink('dns-prefetch', origin);
      this.safeAddLink('preconnect', origin, { crossOrigin: 'anonymous' });
    }

    // Preload dinámico del primer banner (ayuda al LCP)
    this.safeAddLink('preload', firstUrl, { as: 'image' });
  }

 // Helpers
  private getOrigin(url: string): string | null {
    try { return new URL(url).origin; } catch { return null; }
  }

  private safeAddLink(rel: string, href: string, extra?: { [k: string]: any }) {
    // Evita duplicados si vuelves a entrar
    const key = `${rel}|${href}`;
    if ((window as any).__LINK_ADDED__?.has(key)) return;
    (window as any).__LINK_ADDED__ = (window as any).__LINK_ADDED__ || new Set();
    (window as any).__LINK_ADDED__.add(key);

    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (rel === 'preload' && extra?.as) link.as = extra.as;
    if (rel === 'preconnect' && extra?.crossOrigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

private deferAutoplayUntilLCP() {
  const start = () => {
    if (this.heroStarted) return;

    const el = document.querySelector('#carouselExample');
    const hero = document.querySelector('#carouselExample .carousel-item:first-child img') as HTMLImageElement | null;
    if (!el || !hero) return; // aún no hay slides => no inicies

    this.heroStarted = true;
    const c = bootstrap.Carousel.getOrCreateInstance(el, { interval: 7000, ride: false });
    c.cycle();

    this.lcpObserver?.disconnect();
    this.heroMO?.disconnect();
    if (this.autoplayT) clearTimeout(this.autoplayT);
  };

  // 1) Espera a que exista el hero si aún no está en el DOM
  const ensureHero = () => document.querySelector('#carouselExample .carousel-item:first-child img') as HTMLImageElement | null;
  let hero = ensureHero();
  if (!hero) {
    const container = document.querySelector('#carouselExample .carousel-inner');
    if (container) {
      this.heroMO = new MutationObserver(() => {
        hero = ensureHero();
        if (hero) {
          this.heroMO?.disconnect();
          wireHero(hero);
        }
      });
      this.heroMO.observe(container, { childList: true, subtree: true });
    }
  } else {
    wireHero(hero);
  }

  function wireHero(img: HTMLImageElement) {
    if (img.complete) start();
    img.addEventListener('load', start, { once: true });
    img.addEventListener('error', start, { once: true });
  }

  // 2) LCP (buffered) por si llega antes/después
  if ('PerformanceObserver' in window) {
    try {
      this.lcpObserver = new PerformanceObserver((list) => {
        if (list.getEntries().length) start();
      });
      this.lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch {}
  }

  // 3) Fallback
  this.autoplayT = window.setTimeout(start, 6000);
}


onHeroLoaded() {
  if (this.heroStarted) return;
  this.heroStarted = true;

  const el = document.querySelector('#carouselExample');
  if (!el) return;

  const carousel = bootstrap.Carousel.getOrCreateInstance(el, {
    interval: 7000,
    ride: false
  });
  carousel.cycle();
}
  toggleElementos() {
    this.mostrarElementos = !this.mostrarElementos;
  }
  fnExtaerNuevos() {
    let objenv = {
        strAccion: 'getArtsNuevos',
        strConexion: this.strConexion
      }
      this._serviciosService.mostrarCotizaciones(objenv, 'sp_ECommerce')
      .pipe(  takeUntil(this.destroy$) ) // 👈 Usamos takeUntil
      .subscribe(
        result => {
         
         // if(this.arrayNovedades.length>0){
           if (Array.isArray(result) && result.length) { 
             this.arrayNovedades = result
            this.arrayNovedades.forEach(item => {
              item.hovered = false;
              item.oferta= Math.ceil( 100-((item.dblPrecioOferta/item.dblPrecioLista)*100))
            });
            this.arrayNovedades.sort((a, b) => a.dblCantidad - b.dblCantidad);
          }
          
      
         },
        error => {
          var error = <any>error;
        }
      );
    }
    fnExtaerDestacados() {
      let objenv = {
          strAccion: 'getArtsDestacados',
          strConexion: this.strConexion
        }
        this._serviciosService.mostrarCotizaciones(objenv, 'sp_ECommerce')
        .pipe(  takeUntil(this.destroy$) ) // 👈 Usamos takeUntil
        .subscribe(
          result => {
          // if(this.arrayProductosDestacados.length>0){
            if (Array.isArray(result) && result.length) { 
              
            this.arrayProductosDestacados = result
              this.arrayProductosDestacados.forEach(item => {
                item.hovered = false;
                item.oferta= Math.ceil( 100-((item.dblPrecioOferta/item.dblPrecioLista)*100))
              });
              this.arrayProductosDestacados.sort((a, b) => a.dblCantidad - b.dblCantidad);
           }
           this.arrayProductosDestacados.forEach( dest => {
              if(dest.strTipo!=""){
                dest.intDescuento =  (((dest.dblPrecioLista - dest.dblPrecioOferta) /dest.dblPrecioLista)* 100)
                this.arrayLiquidacion.push(dest)
              }
            });
            this.arrayLiquidacion.sort((a, b) => a.dblCantidad - b.dblCantidad);
            console.log(this.arrayProductosDestacados);
           },
          error => {
            var error = <any>error;
          }
        );
      }
      fnExtaerCategorias() {
        // 1. Define un mapa de correspondencia (idealmente en un archivo de constantes)
        const CATEGORY_IMAGE_MAP = {
          "ALMACENAMIENTO Y ORGANIZACION": "./assets/ecommerce/categorias/ALMACENAMIENTO-Y-ORGANIZACION",
          "AMENIDADES": "./assets/ecommerce/categorias/AMENIDADES",
          "ARTICULOS DE LIMPIEZA":"./assets/ecommerce/categorias/ARTICULOS-DE-LIMPIEZA",
          "BOLSA PARA BASURA":"./assets/ecommerce/categorias/BOLSA-PARA-BASURA",
           "BOTES Y CONTENEDORES":"./assets/ecommerce/categorias/BOTES-Y-CONTENEDORES",
           "CARROS UTILITARIOS":"./assets/ecommerce/categorias/CARROS-UTILITARIOS",
            "COMPLEMENTOS PARA BAÑO":"./assets/ecommerce/categorias/COMPLEMENTOS-PARA-BANIO",
            "CONTROL DE AROMAS":"./assets/ecommerce/categorias/CONTROL-DE-AROMAS",
            "DESECHABLES Y BIODEGRADABLES":"./assets/ecommerce/categorias/DESECHABLES-Y-BIODEGRADABLES",
            "EQUIPO DE PROTECCION":"./assets/ecommerce/categorias/EQUIPO-DE-PROTECCION",
            "EQUIPOS Y MAQUINAS DE LIMPIEZA INDUSTRIAL":"./assets/ecommerce/categorias/EQUIPOS-Y-MAQUINAS-DE-LIMPIEZA-INDUSTRIAL",
            "HIGIENE Y CUIDADO PARA MANOS":"./assets/ecommerce/categorias/HIGIENE-Y-CUIDADO-PARA-MANOS",
            "MICROFIBRA":"./assets/ecommerce/categorias/MICROFIBRA",
            "PAPEL Y DESPACHADORES":"./assets/ecommerce/categorias/PAPEL-Y-DESPACHADORES",
            "QUIMICOS PARA LIMPIEZA":"./assets/ecommerce/categorias/QUIMICOS-PARA-LIMPIEZA",
            "QUIMICOS PARA MANTENIMIENTO":"./assets/ecommerce/categorias/QUIMICOS-PARA-MANTENIMIENTO",
            "TAPETES":"./assets/ecommerce/categorias/TAPETES",
            "UTENSILIOS DE COCINA":"./assets/ecommerce/categorias/UTENSILIOS-DE-COCINA",
            "NOVA CLEAN":"./assets/ecommerce/categorias/NOVA-CLEAN",
            "WIPERS Y TOALLAS HUMEDAS":"./assets/ecommerce/categorias/WIPERS-Y-TOALLAS-HUMEDAS"
       
        };

        let objenv = {
            strAccion: 'getCategorias',
            strConexion: this.strConexion
          }
          this._serviciosService.mostrarCotizaciones(objenv, 'sp_ECommerce')
          .pipe(  takeUntil(this.destroy$) ) // 👈 Usamos takeUntil
          .subscribe(
            result => {
            
              this.arrayCategorias = result
              this.arrayCategorias.forEach(cat => {
                cat.seeHov = false;
                 cat.imagenAlta = CATEGORY_IMAGE_MAP[cat.strCategoria] || "./assets/ecommerce/categorias/NO_DISPONIBLE.jpg";
                 cat.sizes ="(max-width: 600px) 215px, 307px"
  // Puedes usar el mismo mapa para imagenAlta si el nombre de archivo es similar:
  // cat.imagenAlta = cat.imagen.replace('.webp', '-alta.webp'); 

              /*  cat.imagen = cat.strCategoria =="ALMACENAMIENTO Y ORGANIZACION" ?"./assets/ecommerce/categorias/almacenamiento-y-organizacion.webp":
                cat.strCategoria =="AMENIDADES"?"./assets/ecommerce/categorias/amenidades.png": 
                cat.strCategoria =="ARTICULOS DE LIMPIEZA"?"./assets/ecommerce/categorias/articulos-de-limpieza.webp":
                cat.strCategoria =="BOLSA PARA BASURA"?"./assets/ecommerce/categorias/bolsas-para-basura.webp":
                cat.strCategoria =="BOTES Y CONTENEDORES"?"./assets/ecommerce/categorias/Botes-y-contenedores.webp":
                cat.strCategoria =="CARROS UTILITARIOS"?"./assets/ecommerce/categorias/Carros-utilitarios.webp":
                cat.strCategoria =="COMPLEMENTOS PARA BAÑO"?"./assets/ecommerce/categorias/Complementos-para-bano.webp":
                cat.strCategoria =="CONTROL DE AROMAS"?"./assets/ecommerce/categorias/Control-de-aromas.png":
                cat.strCategoria =="DESECHABLES Y BIODEGRADABLES"?"./assets/ecommerce/categorias/Desechables-y-biodegradables.webp":
                cat.strCategoria =="EQUIPO DE PROTECCION"?"./assets/ecommerce/categorias/Equipo-de-proteccion.webp":
                cat.strCategoria =="EQUIPOS Y MAQUINAS DE LIMPIEZA INDUSTRIAL"?"./assets/ecommerce/categorias/Equipos-y-maquinas-de-limpieza-industrial.webp":
                cat.strCategoria =="HIGIENE Y CUIDADO PARA MANOS"?"./assets/ecommerce/categorias/Higiene-y-cuidado-para-manos.webp":
                cat.strCategoria =="MICROFIBRA"?"./assets/ecommerce/categorias/Microfibra.webp":
                cat.strCategoria =="PAPEL Y DESPACHADORES"?"./assets/ecommerce/categorias/Papel-y-despachadores.webp":
                cat.strCategoria =="QUIMICOS PARA LIMPIEZA"?"./assets/ecommerce/categorias/Quimicos-para-limpieza.webp":
                cat.strCategoria =="QUIMICOS PARA MANTENIMIENTO"?"./assets/ecommerce/categorias/Quimicos-para-mantenimiento.webp":
                cat.strCategoria =="TAPETES"?"./assets/ecommerce/categorias/Tapetes.png":
                cat.strCategoria =="UTENSILIOS DE COCINA"?"./assets/ecommerce/categorias/Utensilios-de-cocina.webp":
                cat.strCategoria =="NOVA CLEAN"?"./assets/ecommerce/categorias/Nova-Clean.webp":
                cat.strCategoria =="WIPERS Y TOALLAS HUMEDAS"?"./assets/ecommerce/categorias/Wipers-y-toallas-humedas.png":"./assets/ecommerce/categorias/NO_DISPONIBLE.jpg"
             
             
                 cat.imagenAlta = cat.strCategoria =="ALMACENAMIENTO Y ORGANIZACION" ?"./assets/ecommerce/categorias/almacenamiento-y-organizacion.webp":
                cat.strCategoria =="AMENIDADES"?"./assets/ecommerce/categorias/amenidades.webp": 
                cat.strCategoria =="ARTICULOS DE LIMPIEZA"?"./assets/ecommerce/categorias/articulos-de-limpieza.webp":
                cat.strCategoria =="BOLSA PARA BASURA"?"./assets/ecommerce/categorias/bolsas-para-basura.webp":
                cat.strCategoria =="BOTES Y CONTENEDORES"?"./assets/ecommerce/categorias/Botes-y-contenedores.webp":
                cat.strCategoria =="CARROS UTILITARIOS"?"./assets/ecommerce/categorias/Carros-utilitarios.webp":
                cat.strCategoria =="COMPLEMENTOS PARA BAÑO"?"./assets/ecommerce/categorias/Complementos-para-bano.webp":
                cat.strCategoria =="CONTROL DE AROMAS"?"./assets/ecommerce/categorias/Control-de-aromas.webp":
                cat.strCategoria =="DESECHABLES Y BIODEGRADABLES"?"./assets/ecommerce/categorias/Desechables-y-biodegradables.webp":
                cat.strCategoria =="EQUIPO DE PROTECCION"?"./assets/ecommerce/categorias/Equipo-de-proteccion.webp":
                cat.strCategoria =="EQUIPOS Y MAQUINAS DE LIMPIEZA INDUSTRIAL"?"./assets/ecommerce/categorias/Equipos-y-maquinas-de-limpieza-industrial.webp":
                cat.strCategoria =="HIGIENE Y CUIDADO PARA MANOS"?"./assets/ecommerce/categorias/Higiene-y-cuidado-para-manos.webp":
                cat.strCategoria =="MICROFIBRA"?"./assets/ecommerce/categorias/Microfibra.webp":
                cat.strCategoria =="PAPEL Y DESPACHADORES"?"./assets/ecommerce/categorias/Papel-y-despachadores.webp":
                cat.strCategoria =="QUIMICOS PARA LIMPIEZA"?"./assets/ecommerce/categorias/Quimicos-para-limpieza.webp":
                cat.strCategoria =="QUIMICOS PARA MANTENIMIENTO"?"./assets/ecommerce/categorias/Quimicos-para-mantenimiento.webp":
                cat.strCategoria =="TAPETES"?"./assets/ecommerce/categorias/Tapetes.webp":
                cat.strCategoria =="UTENSILIOS DE COCINA"?"./assets/ecommerce/categorias/Utensilios-de-cocina.webp":
                cat.strCategoria =="NOVA CLEAN"?"./assets/ecommerce/categorias/Nova-Clean.webp":
                cat.strCategoria =="WIPERS Y TOALLAS HUMEDAS"?"./assets/ecommerce/categorias/Wipers-y-toallas-humedas.webp":"./assets/ecommerce/categorias/NO_DISPONIBLE.jpg"
                */
             
             
              });
             // this.cdRef.markForCheck(); // 👈 ¡CLAVE! Marca la vista para verificación
             },
            error => {
              var error = <any>error;
            }
          );
        }
      fnIrDetalle(obj:any){
 
        // Componente de origen
        //this.router.navigate(['/tienda-art', obj]);
        const url = ['/tienda', this.slugify(obj.strCategoria),this.slugify(obj.strGrupo), this.slugify(obj.strDescripcion1) ]; // Sin .html, sin skuid
        this.router.navigate(url, { queryParams: { skuID: obj.strArticulo }}); // Con parámetros de consulta
      }

      fnIrSubLinea(obj:any){
        // Componente de origen
     /*   this.router.navigate(['/tienda-categoria'], { 
          queryParams: { strCategoria: obj.strCategoria }
      }); */
          localStorage.setItem('strCategoria_ecommerce',obj.strCategoria);
          this.router.navigate(['/tienda',this.slugify(obj.strCategoria)])

      }
  
 slugify(text: string): string {
    if (!text) return '';

    let slug = text.toLowerCase();

    // Reemplazar la "ñ" por "n"
    slug = slug.replace(/ñ/g, 'n');

    // Eliminar acentos y otros caracteres especiales
    slug = slug.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Quita acentos

    // Reemplazar caracteres no alfanuméricos y espacios con guiones
    slug = slug.replace(/[^a-z0-9 -]/g, '') // Remueve caracteres inválidos
               .replace(/\s+/g, '-')       // Reemplaza espacios con guiones
               .replace(/-+/g, '-');       // Remueve guiones duplicados

    return slug;
  }
  addToCart(obj: any) {
    //const objString = JSON.stringify(obj); // Convertir el objeto a string
   // const encryptedData = this.encryptData(objString);

    /*this.router.navigate(['/tienda-art'], { 
     
     // queryParams: { data: encryptedData } // Enviar el string como parámetro
      queryParams: {  Articulo:obj.strDescripcion,Categoria: obj.strCategoria , subCategoria: obj.strGrupo,data: encryptedData}
    });*/

    const url = ['/tienda', this.slugify(obj.strCategoria), this.slugify(obj.strGrupo), this.slugify(obj.strDescripcion)]; // Sin .html, sin skuid
    this.router.navigate(url, { queryParams: { skuID: obj.strArticulo } }); // Con parámetros de consulta
  }

  onImageError(event: any) {
    // Si hay un error al cargar la imagen, usamos una imagen por defecto
    event.target.src = 'assets/Fondos/image.png';
  }

  fnNav(nav: string) {
    this.router.navigate(['/tiendaproducto'], {
      queryParams: { strTipo: nav }
    });
  }
 

  fnGetBannersEcommerce() {
    this.arrayBannerEcommerce = [];
    let objParam = {
      strAccion: "getBanners",
      strTipo: "ecommerce",
      strConexion: this.strConexion
    };

    this._serviciosService.mostrarCotizaciones(objParam, 'sp_PartNer')
    .pipe(  takeUntil(this.destroy$) ) // 👈 Usamos takeUntil
    .subscribe(
      result => {

        if (result && result.length > 0) {
          result.forEach(ban => {
          if (ban.strEstatus == '1') {
              this.arrayBannerEcommerce.push(ban)
            }
          });
          this.arrayBannerEcommerce.sort((a, b) => {
            return Number(a.strMoneda) - Number(b.strMoneda);
          });


          this.onBannersLoaded(this.arrayBannerEcommerce);
              
        
      //  for (let index = 0; index < this.arrayBannerEcommerce.length; index++) {
         console.log(this.arrayBannerEcommerce)
          const link = this.document.createElement('link');
          
          link.as = 'image';
          
          link.href =  this.arrayBannerEcommerce[0].strUrl;
          //if(index==0){
            link.rel = 'preload';
            link.setAttribute('fetchpriority', 'high');
         // }
         // else{
            //link.rel = 'prefetch';
             //link.setAttribute('loading', 'lazy');
          //}
          
          this.document.head.appendChild(link);
          
       // }
          /**fin lcp */
        } 
      });
  }

  fnGetBannersPartner() {
    this.arrayBannerPartner = [];
    let objParam = {
      strAccion: "getBanners",
      strTipo: "partner",
      strConexion: this.strConexion
    };

    this._serviciosService.mostrarCotizaciones(objParam, 'sp_PartNer')
    .pipe(  takeUntil(this.destroy$) ) // 👈 Usamos takeUntil
    .subscribe(
      result => {

        if (result && result.length > 0) {
          result.forEach(ban => {
            if (ban.strEstatus == '1') {
              this.arrayBannerPartner.push(ban)
            }
          });
          this.arrayBannerPartner.sort((a, b) => {
            return Number(a.strMoneda) - Number(b.strMoneda);
          });
        } 
      });
  }

  isInternal(url: string): boolean {
    return !!url && url.trim().startsWith('/');
  }

  getPath(url: string): string {
    if (!url) return '/';
    const u = url.trim();
    // si es interno, devuelve solo el path (sin querystring)
    if (this.isInternal(u)) return u.split('?')[0];
    // externo: no se usa con routerLink
    return '';
  }

  getQuery(url: string): any {
    const q: any = {};
    if (!url) return q;
    const u = url.trim();
    if (!this.isInternal(u)) return q;
    const idx = u.indexOf('?');
    if (idx < 0) return q;
    const search = new URLSearchParams(u.substring(idx + 1));
    search.forEach((v, k) => (q[k] = v));
    return q;
  }

  normalizeExternal(url: string): string {
    if (!url) return '#';
    const u = url.trim();
    return /^https?:\/\//i.test(u) ? u : `https://${u}`;
  }
    ngOnDestroy(): void {
      if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.destroy$.next(); // Emitimos un valor
    this.destroy$.complete(); // Cerramos el Subject
     this.lcpObserver?.disconnect();
  if (this.autoplayT) clearTimeout(this.autoplayT);
  }
}
 